import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';
import {
  formatInsufficientTokenBudgetMessage,
  parseInsufficientTokenBudgetError,
} from './quotes-api-error';

export const paymentRequiredInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 402) {
        const parsed = parseInsufficientTokenBudgetError(error);
        const detail = parsed
          ? formatInsufficientTokenBudgetMessage(parsed)
          : typeof error.error?.detail === 'string'
            ? error.error.detail
            : 'No token budget available.';

        messageService.add({
          severity: 'warn',
          summary: 'Payment required',
          detail,
          life: 8000,
        });
      }
      return throwError(() => error);
    }),
  );
};
